import type { ClHealth, ClLpPhase } from './types';

export const GROWTH_CAMPAIGN_LIST_META = {
  eyebrow: 'Google Ads · Campaigns',
  titleLead: 'Your',
  titleAccent: 'campaigns',
  description:
    'April 2026 — every number here comes from real booked appointments, not just ad clicks. ELVA optimizes each campaign hourly so your budget always chases the patients most likely to show up.',
} as const;

export const CL_HEALTH_LABELS: Record<ClHealth, string> = {
  optimal: 'Optimal',
  learning: 'Learning',
  attention: 'Needs Attention',
  paused: 'Paused',
};

export const CL_LP_PHASE_LABELS: Record<ClLpPhase, string> = {
  exploration: 'Exploring',
  validation: 'Validating',
  exploitation: 'Winner running',
  converged: 'Stable winner',
};
